"use client"

import { Button, Col, Form, Input, Row, theme } from "antd"
import TEBreadcrumb from "../common/TEBreadcrumb"
import { useTranslation } from "react-i18next"
import Title from "../common/Typography/Title"
import ControllerWarpper from "../common/ControllerWarpper"
import { useForm } from "react-hook-form"
import Text from "../common/Typography/Text"
import Link from "../common/Typography/Link"
import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks"
import { thunks } from "@/lib/redux/thunks"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from 'yup'
import { validatePhoneNumber } from "@/utils/validates/validatePhoneNumber"
import { toast } from "react-toastify"

const schema = yup.object({
  fullname: yup.string().required("booking.fullname_input_required_message"),
  phone: yup.string().required("booking.phonenumber_input_required_message").test(
    "contact.phone",
    "booking.phonenumber_input_invalid_message",
    validatePhoneNumber
  ),
  email: yup.string().optional().nullable(),
  content: yup.string().required("common.content_required_message"),
})

const Contact = () => {
  const { t } = useTranslation()
  const token = theme.useToken().token
  const form = useForm({
    resolver: yupResolver(schema)
  })
  const dispatch = useAppDispatch()
  const sending = useAppSelector(state => state.user.customer_temp.loading)

  return (
    <Row
      className="contact__wrapper"
      justify='center'
    >
      <Col className="contact" span={24}>
        <Row>
          <TEBreadcrumb
            separator="|"
            items={[
              {
                title: t("common.home"),
                path: '/'
              },
              {
                title: t("common.contact"),
                path: '/lien-he'
              }
            ]}
          />
        </Row>
        <Row>
          <Title style={{ color: token.colorPrimary }} level={2}>
            {t("contact.form_title")}
          </Title>
        </Row>
        <Form layout='vertical'>
          <Row gutter={15}>
            <Col span={24}>
              <ControllerWarpper
                control={form.control}
                name={"fullname"}
                label={t("common.fullname")}
                required
                render={({ field }) => {
                  return (
                    <Input
                      size='large'
                      placeholder={t("common.fullname_placeholder")}
                      {...field}
                    />
                  )
                }}
              />
            </Col>
            <Col xs={24} md={12} xl={12}>
              <ControllerWarpper
                control={form.control}
                name={"phone"}
                label={t("common.phonenumber")}
                required
                render={({ field }) => {
                  return (
                    <Input
                      size='large'
                      placeholder={t("common.phonenumber_placeholder")}
                      {...field}
                    />
                  )
                }}
              />
            </Col>
            <Col xs={24} md={12} xl={12}>
              <ControllerWarpper
                control={form.control}
                name={"email"}
                label="Email"
                render={({ field }) => {
                  return (
                    <Input
                      size='large'
                      placeholder={t("common.email_placeholder")}
                      {...field}
                    />
                  )
                }}
              />
            </Col>
            <Col span={24}>
              <ControllerWarpper
                control={form.control}
                name={"content"}
                label={t("common.content")}
                required
                render={({ field }) => {
                  return (
                    <Input.TextArea
                      rows={5}
                      size='large'
                      {...field}
                    />
                  )
                }}
              />
            </Col>
            <Col span={24} style={{ marginTop: '1rem' }}>
              <Button
                loading={sending}
                size='large'
                block
                type='primary'
                onClick={form.handleSubmit(async (values) => {
                  try {
                    await dispatch(thunks.customer_temp({
                      body: {
                        TYPE: 'JSON',
                        title: `YÊU CẦU LIÊN HỆ: ${values.email ? `${values.email} - ` : ''}${values.content}`,
                        fullName: values.fullname,
                        phoneNumber: values.phone,
                        source: "web"
                      }
                    })).unwrap()
                    toast.success(t("booking.request_booking_succeed"))
                    form.reset({
                      fullname: "",
                      phone: "",
                      email: "",
                      content: ""
                    })
                  } catch (error) {
                    toast.error(t("booking.request_booking_failed"))
                  }

                })}
              >
                {t("booking.submit_request")}
              </Button>
            </Col>
          </Row>
        </Form>
        <Row>
          <Title style={{ color: token.colorPrimary }} level={2}>
            {t("contact.company_info_title")}
          </Title>
        </Row>
        <Row style={{ marginBottom: '0.5rem' }}>
          <Text className="layout__footer--address">
            <Text strong>{t("home.office")}</Text>: <Link href="https://maps.app.goo.gl/WzT2FxUCqzu9aMES6" target='_blank'><Text>{process.env.NEXT_PUBLIC_COMPANY_ADDRESS || ""}</Text></Link>
          </Text>
        </Row>
        <Row style={{ marginBottom: '0.5rem' }}>
          <Text className="layout__footer--address">
            <Text strong>{t("home.hc_office")}</Text>: <Link href="https://maps.app.goo.gl/5qBtKsDzY3wJ1cy36" target='_blank'>
              <Text>
                290D/8 Dương Bá Trạc, P. Chánh Hưng, TP. Hồ Chí Minh
              </Text>
            </Link>
          </Text>
        </Row>
        <Row style={{ marginBottom: '0.5rem' }}>
          <Text className="layout__footer--email"><Text strong>{t("home.call_center")}</Text>: {process.env.NEXT_PUBLIC_COMPANY_PHONE || ""}</Text>
        </Row>
        <Row style={{ marginBottom: '0.5rem' }}>
          <Text className="layout__footer--email">
            <Text strong>Email</Text>: {process.env.NEXT_PUBLIC_COMPANY_EMAIL}
          </Text>
        </Row>
      </Col>
    </Row>
  )
}

export default Contact